<template>
  <v-img
    :src="image"
    id="main_image"
    style="max-width: 100%; max-height: 500px; object-fit: cover;"
  >

  <v-layout align-end row fill-height>
    <v-flex md12 class="title_background">
      <div
        :class="{'text-27-security post-image-title pt-3': $vuetify.breakpoint.smAndUp, 'text-14-security post-image-title': $vuetify.breakpoint.smAndDown}"
        style="color: #28385C; z-index: 100;"
      >{{title}}</div>
    </v-flex>
  </v-layout>
    <a
      @click.prevent="downloadItem(image, title)"
      :href="image"
      style="position: absolute; right: 12px; bottom: 8px; z-index: 2;"
    >
      <img src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/cloud-arrow-down-solid.svg" class="icon-cloud" alt="">
    </a>
  </v-img>
</template>

<script>
import axios from "axios";

export default {
  props: {
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  methods: {
    downloadItem(url, title) {
      
      axios.get(url, { responseType: "blob" }).then(({ data }) => {
        let blob = new Blob([data], { type: data.type });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "imagen noticia " + title;
        try {
          link.click()
        } catch(error) {
          console.error(error);
        };
      });
    },
  }
};
</script>

<style>
.post-image-title {
  font-weight: 600;

  opacity: 1 !important;
  padding: 0;
  letter-spacing: 0px;
  padding-left: 24px;
}

.title_background {
  background: rgba(250, 250, 250, 0.7);
  height: 27%;
  margin-top: -35px;
}
.icon-cloud{
  width: 24px;
  filter: invert(100%) sepia(100%) saturate(1%) hue-rotate(66deg) brightness(102%) contrast(102%);
}
.icon-cloud:hover{
  filter: invert(47%) sepia(44%) saturate(541%) hue-rotate(47deg) brightness(95%) contrast(89%);
}
</style>